// # FILE: packages/shared/src/lib/mask-phone.ts
// # PURPOSE: Маскирование номера телефона для отображения в UI (ADR-001 2.7).
// # SCOPE: Используется во всех местах отображения телефона, кроме форм ввода.
// # INPUT: phone — строка номера телефона
// # OUTPUT: замаскированная строка: "+7 (999) ***-**-67"

/**
 * Маскирует номер телефона для отображения в UI.
 * Оставляет первые 4 цифры (код страны и код оператора) и последние 2 цифры.
 * @param phone — номер телефона в любом формате
 * @returns замаскированный номер
 *
 * Примеры:
 *   "+7 (999) 123-45-67" → "+7 (999) ***-**-67"
 *   "+79991234567"       → "+7 (***) ***-**-67"
 *   null/undefined       → ""
 */
export function maskPhone(phone: string | null | undefined): string {
  if (!phone) return "";

  // Убираем все нецифровые символы кроме +
  const cleaned = phone.replace(/[^\d+]/g, "");

  if (cleaned.length < 4) return phone;

  // Для российских номеров: +7XXXXXXXXXX → +7 (XXX) ***-**-XX
  if (cleaned.startsWith("7") || cleaned.startsWith("+7")) {
    const code = cleaned.length >= 12 ? cleaned.substring(0, 2) : "+7"; // +7
    const area = cleaned.substring(2, 5);
    return `${code} (${area}) ***-**-${cleaned.slice(-2)}`;
  }

  // Для остальных номеров: код страны первые 1-3 цифры
  const prefix = cleaned.length >= 4 ? cleaned.slice(0, 4) : cleaned;
  return `${prefix} ***-**-${cleaned.slice(-2)}`;
}
